import { Box } from "@cjdev-internal/visual-stack-x/Box";
import { Text } from "@cjdev-internal/visual-stack-x/Text";
import { useIntl } from "hooks";
import React from "react";
import messages from "../messages";
import { DateMetric, EngagementMetric, NumericMetric } from "../metrics";
import { MetricsGrid } from "../MetricsGrid";

export const YouTubeMetrics = ({ metrics }) => {
  const intl = useIntl();
  return (
    <Box direction="column" gap="2xl">
      <MetricsGrid>
        <NumericMetric name="subscribers" value={metrics.subscribers} />
        <DateMetric
          name="dateLastVideoUploaded"
          value={metrics.dateLastVideoUploaded}
        />
        <NumericMetric
          name="accountTotalVideos"
          value={metrics.accountTotalVideos}
        />
        <NumericMetric
          name="accountTotalViews"
          value={metrics.accountTotalViews}
        />
        <NumericMetric
          name="accountMonthlyViews"
          value={metrics.accountMonthlyViews}
        />
        <NumericMetric
          name="accountViewsPerVideo"
          value={metrics.accountViewsPerVideo}
        />
      </MetricsGrid>
      <Box direction="column" gap="large">
        <Text weight="medium" size={14}>
          {intl.formatMessage(messages.timePeriodLast20Posts)}
        </Text>
        <MetricsGrid>
          <EngagementMetric
            label={metrics.engagementLabel}
            rate={metrics.engagementRate20Posts}
            socialPlatform="youtube"
          />
          <NumericMetric
            name="likesPerPost20Posts"
            value={metrics.likesPerPost20Posts}
          />
          <NumericMetric
            name="commentsPerPost20Posts"
            value={metrics.commentsPerPost20Posts}
          />
          <NumericMetric
            name="viewsPerPost20Posts"
            value={metrics.viewsPerPost20Posts}
          />
        </MetricsGrid>
      </Box>
    </Box>
  );
};
